(function (document, window) {
  'use strict';

  if (window.__sunnoRepairR1LoaderStarted) return;
  window.__sunnoRepairR1LoaderStarted = true;

  /* --------------------------------------------------------------------------
     r3k, 23.08.2026 — schlanker geladen, gleiches Verhalten.

     Alexander: "Bitte vereinfache diese fuenf Schichten, fasse sie zusammen,
     sodass das Ganze einfach und auch schnell wird. Es laedt auch schon
     ziemlich lange. Hauptsache, es ist erst einmal stabil."

     Drei Eingriffe, alle drei umkehrbar:

     1. Die sechs eigenen Pflegeschichten stehen jetzt in einer Datei
        (sunno-buendel-20260823.js) - Inhalt unveraendert, Reihenfolge
        unveraendert. Sechs Umlaeufe werden einer.

     2. Die Intent-Schichten sind abgeschaltet. sunno-intent-router.js zog
        Themenseiten, Priority-Bundle, Progress-Fix, Anlagenvergleich und
        Unanswered-Fix in vielen kleinen Stueckdateien nach - zusammen ueber
        dreissig Anfragen und bis zu acht Sekunden Wartezeit. Die Themenseiten
        darin waren zudem eines der drei Tore, die gepflegte Antworten
        ueberschrieben haben. Die Aufgaben decken heute die Fachlogik und die
        Vorlagen ab.

     3. Die Kettendateien werden vorab parallel angefordert (preload). Die
        Ausfuehrung bleibt streng nacheinander - nur das Warten auf das Netz
        faellt weg.

     Rollback einzeln moeglich: Buendel gegen die sechs Zeilen tauschen,
     ladeIntentSchichten() wieder aufrufen, vorladen() weglassen.

     r3o: zwei neue Chips (Dat, 23.08.). 'Planen' buendelt das Planungs-
     wissen aus Videos und FAQs (neue Vorlage planung-wissen), 'Dachplanung'
     ersetzt 'K2 Base' und fuehrt zur Dachberechnung (neue Vorlage
     dachplanung); montage-wissen entsprechend aufgeteilt. Chip-Liste:
     sunno-canonical-20260823-v11.js. Zaehlungen auf 10 Chips angepasst
     (repair-Audit, Selbsttest).

     r3s: drei Dinge. (1) Tonleiter der Schriftgroessen - Ueberschrift 30 px
     fett, Einleitung 20 px ohne Deckkraftabzug, Fliesstext 18, Detailbloecke
     17. Vorher war die Einleitung mit 16 px kleiner als der Fliesstext mit 24.
     (2) Vorlage Komplettanlagen - der Chip lief vorher in eine Produktliste.
     (3) sunno-abnahme-20260824.js: faehrt die Soll-Liste aus der Vorlagendatei
     ab und meldet JEDE Abweichung. Das ist die Antwort auf die staendigen
     Ruecksetzungen - eine verlorene Antwort faellt jetzt beim Seitenaufruf auf
     statt nach Wochen. SUNNO_ABNAHME.schnell().

     r3r: das Eingabefeld zeigt seinen Zustand. Steht dort noch ein fremder
     Text (Vorschlagsfrage oder die zuletzt gestellte Frage), schreibt es
     gedaempft und kursiv und wird beim Hineinklicken komplett markiert - die
     Markierung ist die Rueckmeldung, dass das naechste Zeichen alles ersetzt.
     Beim ersten eigenen Zeichen springt es auf normale Schrift.

     r3q: auch die Linkliste bringt ihren eigenen weissen Grund mit. #textcol
     traegt inzwischen selbst die helle Antwortkarte - die weisse Linkschrift
     stand damit auf hellem Grund. Grundregel jetzt: kein eingesetzter Block
     ohne eigenen deckenden Hintergrund.

     r3p: Aufzaehlung und Adressblock schreiben dunkel auf weiss. In r3n hatten
     sie die Farben der Linkliste - die sitzt aber AUSSERHALB der hellen
     Antwortkarte. Ergebnis: fast weiss auf fast weiss, unlesbar. Farbe an der
     Einsetzstelle messen, nicht von der Nachbarschicht uebernehmen.

     r3n: Vorlagen koennen jetzt echte Aufzaehlungen und Adressbloecke tragen
     (Felder "punkte" und "adresse"). Der Logik-Kern kennt nur Absaetze - alles,
     was untereinander stehen muss, ging vorher im Fliesstext unter.

     r3m: die Sortierleiste erscheint nur noch, wenn es Produktkarten gibt. Eine
     Schicht des Routers hatte das frueher mitgeraeumt; ohne sie stand ueber
     jeder Textantwort eine Sortierauswahl fuer null Produkte.

     r3l: das Buendel traegt jetzt Wegmarken. Grund steht dort im Kopf -
     sunno-vorlagen-frisch sucht sein eigenes script-Element und fand es im
     Buendel nicht mehr, wodurch der Berater still mit sieben alten statt
     vierzehn gepflegten Vorlagen weiterarbeitete.
  -------------------------------------------------------------------------- */

  /* r3v, 24.08.2026 — vier gemessene Sparmassnahmen, alle einzeln umkehrbar.
     Serdar (Dat) am 24.08.: "Beobachter, die an der ganzen Seite haengen,
     kosten bei jeder DOM-Aenderung Zeit — und die Slideshow aendert dauernd
     etwas." Gemessen am selben Tag: 500 DOM-Aenderungen kosteten ohne Sunno
     19,1 ms, mit Sunno 32,6 ms.

     1. Der Beobachter hier ist weg. Er hing an der ganzen Seite, ohne
        Zwischenpuffer, und schrieb dabei nichts weiter als vier
        Kennzeichnungen an zwei Elemente. Dieselben vier Kennzeichnungen setzen
        jetzt die Ereignisse, auf die er ohnehin gehoert hat, plus drei
        abgezaehlte Blicke in den ersten zwei Sekunden.

     2. Der Selbsttest (10 KB) kommt erst auf Zuruf. Der Aufruf bleibt
        SUNNO_SELBSTTEST.run(); die Datei wird dabei nachgeholt.

     3. loadStyle erkennt jetzt auch Stylesheets, die eine andere Schicht schon
        eingehaengt hat. Gemessen: sunno-final.css und canonical-v9.css wurden
        zweimal geladen, weil canonical sein CSS selbst ans head-Ende haengt
        und die Kennzeichnung dieser Datei nicht traegt.

     4. Im Buendel: der Feinschliff-Takt endet, sobald dreimal nichts mehr zu
        tun war (vorher fest 60 Runden ueber 15 Sekunden mit je fuenf
        DOM-Schreibzugriffen). Die Abnahme laeuft in der Leerlaufzeit, genau
        einmal je Seitenaufruf, und wartet auf das Sortiment fuenf statt
        zwanzig Sekunden.

     Rollback einzeln: (1) Beobachter-Zeilen zurueck, (2) selbsttest in KETTE,
     (3) Zusatzpruefung in loadStyle entfernen, (4) im jeweiligen Modul.
  */

  /* r7a, 25.08.2026 — der Neubau liegt NEBEN dem Bestand.

     Alexander hat sich fuer den parallelen Neubau entschieden. Mit ?sunno=v2
     laedt diese Datei nur noch vier Dateien statt fuenfzehn: die Daten, das
     Gehirn, den Adapter und sunno-v2-20260912g.js. Alles andere - die
     kanonische Schicht, die Bedienschicht, der Eingangs-Schutz, das Buendel,
     Logbuch, Schliessen, Kompat, Tempo, Rollen, Treffer - bleibt aus.

     Ohne den Zusatz aendert sich NICHTS. Die alte Kette laeuft Zeile fuer
     Zeile wie vorher. Rollback ist damit das Weglassen des Zusatzes in der
     Adresse; ein Rueckbau im Theme ist nicht noetig.

     Warum ueberhaupt: am 25.08. erstmals in einem Fenster gemessen, das
     wirklich zeichnet (vorher lief requestAnimationFrame in meinen Messungen
     nie, deshalb lief der Bremsklotz an jeder Messung vorbei):
     4 Bilder je halbe Sekunde im Leerlauf, 3611 ms je getipptem Buchstaben,
     98471 Rueckrufe der Seitenbeobachter, 49951 Anmeldungen von Bildrahmen,
     7 Beobachter an der ganzen Seite. Antworten dagegen in 446 bis 858 ms -
     genau Alexanders "Buttons sind blitzschnell, nur schreiben kannst du
     nicht mehr". */

  var VERSION = '20260912-anlagen-s1g';
  var currentScript = document.currentScript || document.scripts[document.scripts.length - 1];
  var loadedScripts = Object.create(null);

  /* Der Schalter.

     r7b, 25.08.2026 — KORREKTUR eines eigenen Denkfehlers. Bis r7a hing der
     Schalter allein an der Adresse, und ich habe das Alexander als Vorteil
     verkauft ("kein Keks, kein Speicher, nichts was haengen bleibt").

     Genau daran ist der Test gescheitert. Alexander: "Am Anfang lief es
     relativ flott, aber mit laengerer Zeit habe ich sicherlich zehn Fragen
     eingegeben. Es wird immer langsamer." In der Messung ist v2 ueber sechzehn
     Fragen unveraendert schnell - mit Bildern, Video, Fremdskripten und
     Scrollen. Was aber passiert: JEDER Klick, der die Seite verlaesst (eine
     Produktkarte in der Antwort!), verliert den Zusatz in der Adresse. Zurueck
     auf der Startseite laeuft dann die ALTE Kette - und deren Signatur ist
     woertlich "die ersten zwei Fragen gehen, dann wird es zaeh".

     Deshalb: der Zusatz wird fuer den Tab gemerkt (sessionStorage, gilt bis
     der Tab zugeht). Ausdruecklich zurueck geht es mit ?sunno=alt.
     Kein Keks, keine Wirkung auf andere Tabs, kein Zustand, der Wochen
     spaeter noch jemanden verwirrt. */
  /* r8a, 26.08.2026 - DIE VOREINSTELLUNG IST JETZT v2.

     Was am 26.08. passiert ist: Alexander hat dieses Theme live genommen und
     auf www.inutec-int.com getestet - ohne Zusatz in der Adresse. Bis r7h
     hiess "ohne Zusatz" aber: die ALTE Kette laeuft, mitsamt repair.js und
     seinem Beobachter ueber der ganzen Seite. Ergebnis beim Kunden: erst
     fluessig, dann immer langsamer, dann eingefroren - exakt der Fehler, den
     v2 behebt. Ueber den Testlink mit ?sunno=v2 war alles schnell, live war
     alles alt. Kein einziges Byte des Neubaus war beim Kunden.

     Der eigentliche Fehler sass in der Messdisziplin: JEDE Abnahme trug
     &sunno=v2 in der Adresse. Der Weg des Kunden - die nackte Adresse -
     wurde nie geprueft. Deshalb gilt ab jetzt:

       ohne Zusatz      -> v2 (der Kundenweg)
       ?sunno=alt       -> alte Kette, fuer diesen Tab gemerkt (Notausstieg)
       ?sunno=v2        -> zurueck zur Voreinstellung, loescht den Notausstieg
       ?sunno=test      -> v2 MIT Testanzeige, fuer diesen Tab gemerkt

     Die Testanzeige haengt NICHT mehr an ?sunno=v2: v2 ist jetzt der normale
     Kundenweg, die Anzeige ein Werkzeug. Neue Speicher-Schluessel, damit
     alte Tab-Speicher aus der Testphase nichts mehr schalten. */
  var ALT_SCHLUESSEL = 'sunnoAlt';
  var ANZEIGE_SCHLUESSEL = 'sunnoV2Anzeige';

  function urlSchalter() {
    try {
      var s = String(window.location.search || '');
      if (/[?&]sunno=(alt|v1|aus)(&|$)/.test(s)) return 'alt';
      if (/[?&]sunno=test(&|$)/.test(s)) return 'test';
      if (/[?&]sunno=(v2|neu)(&|$)/.test(s)) return 'v2';
      return null;
    } catch (e) { return null; }
  }

  function altlastenRaeumen(speicher) {
    /* Schluessel aus der Testphase (r7x): sunnoV2 schaltete die Fassung,
       sunnoV2Test die Anzeige. Beide gelten nicht mehr - wer sie noch im
       Tab hat, soll davon nichts merken. */
    try { speicher.removeItem('sunnoV2'); speicher.removeItem('sunnoV2Test'); } catch (e) {}
  }

  function istV2() {
    var wahl = urlSchalter();
    try {
      var sp = window.sessionStorage;
      altlastenRaeumen(sp);
      if (wahl === 'alt') { sp.setItem(ALT_SCHLUESSEL, '1'); sp.removeItem(ANZEIGE_SCHLUESSEL); return false; }
      if (wahl === 'v2') { sp.removeItem(ALT_SCHLUESSEL); sp.removeItem(ANZEIGE_SCHLUESSEL); return true; }
      if (wahl === 'test') { sp.removeItem(ALT_SCHLUESSEL); sp.setItem(ANZEIGE_SCHLUESSEL, '1'); return true; }
      return sp.getItem(ALT_SCHLUESSEL) !== '1';
    } catch (e) {
      /* Kein Speicher (privates Fenster, gesperrte Seite): allein die Adresse
         entscheidet, und ohne Zusatz gilt die Voreinstellung v2. */
      return wahl !== 'alt';
    }
  }

  function istV2Test() {
    var wahl = urlSchalter();
    if (wahl === 'test') return true;
    if (wahl === 'alt' || wahl === 'v2') return false;
    try { return window.sessionStorage.getItem(ANZEIGE_SCHLUESSEL) === '1'; } catch (e) { return false; }
  }

  var FILES = {
    originalTheme: 'tzn-main-tammo-backup.js',
    /* r4t: Der Buendler ist AUS - und zwar nach Messung, nicht nach Gefuehl.
       Gemessen am 25.08.2026: sunno-vorlagen-dat.json wurde 4 x geholt (88 KB),
       gebuendelt nur noch 1 x (Sunno gesamt 204 -> 117 KB, 44 -> 42 Dateien).
       Der Preis war aber zu hoch: mit einem Abruf standen im Motor 7 Vorlagen
       vom Stand 2026-08-20.3 statt 47 vom Stand 2026-08-25.32.
       Grund: das Netz liefert diese Datei auch unter einem frisch erfundenen
       ?v= manchmal in einer alten Fassung. Die VIER Abrufe waren also
       unbeabsichtigt ein Schutz - wer zuletzt schreibt, gewinnt, und einer der
       vier erwischt die frische Fassung. Ein Buendler friert dagegen die erste
       Antwort fuer 30 Sekunden ein.
       87 KB sind kein Grund, 40 Vorlagen zu verlieren. Die Datei liegt im
       Theme; sie kommt zurueck, sobald die Pflegedateien datierte Namen tragen
       (Vorschlag in Abschnitt 7). */
    home: 'sunno-home.js',
    runtime: 'sunno-runtime-safe-20260822.js',
    canonicalJs: 'sunno-canonical-20260823-v11.js',
    canonicalCss: 'sunno-canonical-20260821-v9.css',
    interactionJs: 'sunno-interaction-20260821-v11.js',
    interactionCss: 'sunno-interaction-20260821-v11.css',
    repairJs: 'sunno-repair-20260822.js',
    repairCss: 'sunno-repair-20260822.css',
    /* r4w: Handy-Ansicht. Nur im Sunno-Theme steckt der Hero-Text in
       .sunno-hero-copy, und die bekommt dort eine Breite in vw (38vw). Auf
       einem 390-px-Telefon sind das 148 px - daher ein Buchstabe pro Zeile.
       Dazu die Zeilenhoehe der Ueberschrift, gemessen 26 px bei 83 px Schrift
       (in BEIDEN Themes gleich, faellt aber nur hier auf). */
    mobilCss: 'sunno-mobil-20260825b.css',
    fachlogikDaten: 'sunno-fachlogik-daten-20260822.js',
    fachlogik: 'sunno-fachlogik-20260822.js',
    fachlogikAdapter: 'sunno-fachlogik-adapter-20260822.js',
    logbuch: 'sunno-logbuch-20260822.js',
    selbsttest: 'sunno-selbsttest-20260822.js',
    /* Buendel = vorschlagsfrage + vorlagen-frisch + feinschliff + vorrang +
       chipfragen + ready-waechter + abnahme, unveraendert in dieser Reihenfolge. */
    /* r5a: vorschlagsfrage 1.4 - die Markierung beim Hineinklicken haelt jetzt
       auch mit echter Maus (mouseup-Griff) und gilt bei JEDEM Betreten. */
    buendel: 'sunno-buendel-20260825b.js',
    /* r3w: Antwortfenster wieder schliessbar. Das Chat-Fenster (z-index
       2147483646) liegt ueber Sunnos Schliessen-Kreuz (z-index 60) - gemessen
       am 24.08.2026. Eigene Datei, damit der Rueckbau eine Zeile ist. */
    schliessen: 'sunno-schliessen-20260825c.js',
    /* r3z: Speicher-Kompatibilitaet mit Produktkarten. Wissensbasis in
       sunno-kompat-dat.json - 18 Wechselrichter-Familien mit den
       freigegebenen Speicherfamilien, Grenzen und Herstellerquelle. */
    /* r5b: 2.6 - Einmal-Zeichnen-Riegel gegen den 250-ms-Dauerbeschuss des
       Eingangs-Schutzes (21 sunno:rendered je Speicherfrage, siehe 10v)
       und das doppelte sunno:rendered je Zeichnung entfernt. */
    kompat: 'sunno-kompat-20260825e.js',

    /* r4y: Ruhe beim Tippen. Gemessen am 25.08.: 351 DOM-Aenderungen in 8 s
       bei fokussiertem Feld, 180 davon an den Chips - canonicals Attributpflege
       schreibt unveraenderte Werte neu und weckt damit alle Beobachter.
       Die Huelle ueberspringt gleichwertige data-/aria-Schreibzugriffe,
       haelt die Hero-Videos beim Tippen an und laesst die Box fuer sich
       malen (contain:paint). Grund in 10s. */
    tempo: 'sunno-tempo-20260825g.js',

    /* Rollen-Sperre: das Antwortfenster darf EINMAL je Antwort zu sich
       rollen, und die Hand des Besuchers gewinnt immer. Grund in 10j. */
    rollen: 'sunno-rollen-20260825c.js',

    /* Suchwort nach oben und Videolinks aus sunno-videos-dat.json.
       Grund in 10k. r5c (1.3): die Karte wird nicht mehr abgerissen und neu
       gebaut, wenn sie fuer dieselben Suchworte schon steht - der
       Eingangs-Schutz feuert im ersten Minutenfenster viele sunno:rendered
       hintereinander (10v). */
    treffer: 'sunno-treffer-20260825e.js',

    /* r7a: die neue Auslieferungsschicht. Baut das Geruest einmal, gibt die
       Frage einmal ans Gehirn, zeichnet die Antwort einmal - und tut danach
       nichts mehr. Kein Beobachter, kein Zeitgeber, kein Bildrahmen. */
    v2: 'sunno-v2-20260912g.js',
    /* Grundgestalt von Box und Antwortfenster. In der alten Kette haengt die
       kanonische Schicht diese Datei selbst ein; v2 laedt sie ausdruecklich. */
    tammoStyleCss: 'tammo-style.css'
  };

  /* Vier Dateien in strenger Reihenfolge: Daten, Gehirn, Adapter, Auslieferung. */
  var KETTE_V2 = [
    FILES.fachlogikDaten, FILES.fachlogik, FILES.fachlogikAdapter, FILES.v2
  ];

  /* Dazu vier Wissensschichten, die NEBENHER laufen duerfen - sie liefern
     Daten, keine Bedienung. Am 25.08. jede einzeln nachgezaehlt:
     0 Beobachter, 0 Zeitgeber, 0 Bildrahmen. Genau ein setTimeout in drei von
     ihnen. Deshalb sind sie hier erlaubt.

     Warum sie sein muessen - gemessen an der Antwortbatterie gegen die alte
     Kette: ohne sunno-quellen-runtime fehlten 23 von 24 Links auf
     Wissensartikel (und damit die Videoknoepfe und die Suchwortkarte), ohne
     sunno-shipping-guard blieb "Was kostet der Versand?" ohne Antwort. */
  var NEBEN_V2 = [
    'sunno-quellen-runtime.js',
    'sunno-shipping-guard.js',
    'sunno-victron-pelio.js',
    'sunno-victron-us.js',
    /* r7c: Die Soll-Abnahme mit 34 Pruefpunkten. Rein lesend, aendert nichts,
       laeuft einmal je Seitenaufruf in der Leerlaufzeit und meldet JEDE
       Abweichung von der gepflegten Soll-Liste in der Konsole. Am 25.08.
       nachgezaehlt: 0 Beobachter, 0 Zeitgeber, 0 Bildrahmen.

       Warum sie dazu muss: der Rueckfall auf sieben Vorlagen wurde nur durch
       eine Kontrollmessung entdeckt. Genau dafuer ist dieses Modul gebaut -
       eine verlorene Antwort faellt beim Seitenaufruf auf statt nach Wochen.
       v2 legt den Rohdatensatz ab und feuert sunno:vorlagen-frisch. */
    'sunno-abnahme-20260824.js'
  ];

  /* Reihenfolge der Ausfuehrung. Wird auch zum Vorladen benutzt. */
  var KETTE = [
    /* tempo steht ZUERST: die Schreib-Beruhigung soll sitzen, bevor die
       Heil-Schichten ihre Beobachter starten. */
    FILES.tempo,
    FILES.home, FILES.runtime, FILES.canonicalJs, FILES.interactionJs,
    FILES.repairJs, FILES.fachlogikDaten, FILES.fachlogik, FILES.fachlogikAdapter,
    FILES.logbuch, FILES.buendel, FILES.schliessen, FILES.kompat,
    FILES.rollen, FILES.treffer
  ];
  /* selbsttest steht absichtlich NICHT in der Kette - siehe Punkt 2 oben. */

  var NEBEN = [
    'sunno-quellen-runtime.js',
    /* r4q: Produktwissen ist AUS. Kette der Messungen vom 25.08.2026:
       (1) Der alte Weg (Lader + elf .jsbin-Stuecke) warf beim Parsen
           "Invalid regular expression /^((mehr erfahren|..." - der Motor war
           tot, seit Wochen. Ursache nicht der Code: das Theme traegt die
           richtige Fassung (part03 = 2711 B), ausgeliefert wurde eine alte
           2700-B-Generation, und zwar unter JEDEM Abfrageschluessel.
       (2) Neu gebaut als eine Datei (sunno-produktwissen-20260825.js, 33 KB):
           der Motor lief. 420 Produkte, 402 Kurz- und 420 Langtexte,
           426 strukturierte Fakten, 104 Pflicht- und 150 Kann-Zubehoerlinks,
           7725 Textbloecke.
       (3) Dabei aber gemessen: er holt sunno-product-source.jsbin mit
           2 008 KB - je Seitenaufruf. Und seine Bruecke kann nicht greifen:
           installBridge() verlangt ein globales window.classifyAlle, das es
           in dieser Architektur nicht mehr gibt (die Funktion sitzt auf
           SUNNO_FACHLOGIK). Der Motor haette also 2 MB gekostet und nichts
           beigetragen.
       Deshalb aus. Die Datei liegt im Theme und ist eine Zeile weit weg.
       Naechster Schritt dazu in Abschnitt 7. */
    'sunno-shipping-guard.js',
    'sunno-victron-pelio.js',
    'sunno-victron-us.js'
  ];

  function assetUrl(filename) {
    if (!currentScript || !currentScript.src) return filename;
    var url = new URL(currentScript.src, window.location.href);
    var pathname = url.pathname;
    var slash = pathname.lastIndexOf('/');
    url.pathname = pathname.slice(0, slash + 1) + filename;
    url.search = '';
    url.searchParams.set('v', VERSION);
    return url.toString();
  }

  function isHomePage() {
    var path = (window.location.pathname || '/').replace(/\/+$/, '') || '/';
    if (path === '/' || path === '/index') return true;
    /* Sprach-Startseiten dieses Shops: de, en, sv, fr, es, pl */
    return ['/de', '/en', '/sv', '/fr', '/es', '/pl'].indexOf(path) !== -1;
  }

  function loadStyle(filename) {
    var selector = 'link[data-sunno-repair-style="' + filename + '"]';
    var existing = document.querySelector(selector);
    if (existing) return existing;
    /* Andere Schichten haengen ihr CSS selbst ein, ohne diese Kennzeichnung.
       Dann liegt die Datei schon da und ein zweites Mal laden bringt nichts. */
    var fremd = document.querySelector('link[rel="stylesheet"][href*="' + filename + '"]');
    if (fremd) return fremd;
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = assetUrl(filename);
    link.setAttribute('data-sunno-repair-style', filename);
    (document.head || document.documentElement).appendChild(link);
    return link;
  }

  function loadScript(filename) {
    if (loadedScripts[filename]) return loadedScripts[filename];
    loadedScripts[filename] = new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.src = assetUrl(filename);
      script.async = false;
      script.setAttribute('data-sunno-repair-script', filename);
      script.onload = function () { resolve(filename); };
      script.onerror = function () { reject(new Error(filename + ' konnte nicht geladen werden.')); };
      (document.head || document.documentElement).appendChild(script);
    });
    return loadedScripts[filename];
  }

  function optionalScript(filename) {
    return loadScript(filename).catch(function (error) {
      console.warn('[Sunno Repair R1] Optionale Schicht nicht geladen:', filename, error);
      return null;
    });
  }

  /* Netz parallel, Ausfuehrung nacheinander. Der Browser holt die Dateien
     schon, waehrend die erste noch laeuft; die Kette findet sie dann im
     Zwischenspeicher. Aendert nichts an der Reihenfolge. */
  function vorladen(dateien) {
    if (!document.head) return;
    dateien.forEach(function (name) {
      try {
        var link = document.createElement('link');
        link.rel = 'preload';
        link.as = 'script';
        link.href = assetUrl(name);
        link.setAttribute('data-sunno-vorladen', name);
        document.head.appendChild(link);
      } catch (e) { /* Vorladen ist Kuer, kein Muss */ }
    });
  }

  /* Platzhalter fuer den Selbsttest: gleicher Aufruf, Datei kommt erst dann.
     Das echte Modul traegt eine andere version und ueberschreibt diesen
     Platzhalter beim Laden - deshalb ist die Reihenfolge unkritisch. */
  function selbsttestPlatzhalter() {
    window.SUNNO_SELBSTTEST = {
      version: 'nachlader-' + VERSION,
      nachlader: true,
      run: function () {
        return loadScript(FILES.selbsttest).then(function () {
          var echt = window.SUNNO_SELBSTTEST;
          if (!echt || echt.nachlader) {
            throw new Error('Selbsttest konnte nicht nachgeladen werden.');
          }
          return echt.run();
        });
      }
    };
  }

  function loadOriginalTheme(attempt) {
    var tries = attempt || 0;
    if (window.__sunnoOriginalThemeLoaded || window.__sunnoOriginalThemeLoading) return;
    if (!window.jQuery && tries < 120) {
      window.setTimeout(function () { loadOriginalTheme(tries + 1); }, 50);
      return;
    }

    window.__sunnoOriginalThemeLoading = true;
    optionalScript(FILES.originalTheme).then(function (result) {
      window.__sunnoOriginalThemeLoading = false;
      window.__sunnoOriginalThemeLoaded = Boolean(result);
    });
  }

  function applyReleaseMarkers() {
    var root = document.getElementById('inutec-sunno-startseite');
    if (root) {
      root.setAttribute('data-sunno-release', VERSION);
      root.setAttribute('data-sunno-canonical', '20260823-v11');
      root.setAttribute('data-sunno-interaction', '20260821-v11');
    }
    var panel = document.getElementById('frag-tammo');
    if (panel) panel.setAttribute('data-sunno-release', VERSION);
  }

  function loadBaseStyles() {
    /* r7a: In v2 baut niemand mehr die Grundgestalt zur Laufzeit ein, also
       kommt sie hier - und zwar ZUERST, damit sunno-final.css darueber liegt
       wie bisher. */
    if (istV2()) loadStyle(FILES.tammoStyleCss);
    loadStyle('sunno-final.css');
    loadStyle('sunno-left-fix.css');
    loadStyle(FILES.canonicalCss);
    loadStyle(FILES.interactionCss);
    loadStyle(FILES.repairCss);
    /* r4w: Handy-Ansicht und lesbare Hero-Ueberschrift. Kommt bewusst ZULETZT,
       auch wenn die Regeln durch doppelt genannte Klasse/ID ohnehin gewinnen.
       Rollback: diese Zeile entfernen. Begruendung in 10q. */
    loadStyle(FILES.mobilCss);
  }

  function bootV2() {
    /* Die Testanzeige wird hier gesetzt, weil nur der Lader weiss, ob der
       Zusatz in der Adresse stand oder aus dem Tab-Speicher kam. */
    try {
      if (istV2Test()) document.documentElement.setAttribute('data-sunno-v2-test', '1');
    } catch (e) {}
    loadBaseStyles();
    vorladen(KETTE_V2.concat(NEBEN_V2));
    NEBEN_V2.forEach(function (name) { optionalScript(name); });
    KETTE_V2.reduce(function (kette, name) {
      return kette.then(function () { return optionalScript(name); });
    }, Promise.resolve()).then(function () {
      applyReleaseMarkers();
      window.dispatchEvent(new CustomEvent('sunno:repair-ready', {
        detail: { version: VERSION, v2: true, corruptEngineDisabled: true }
      }));
    });
    /* Bewusst KEINE abgezaehlten Blicke und kein Beobachter: die Kennzeichnung
       setzt v2 selbst, wenn es sein Geruest baut. */
  }

  function bootSunno() {
    if (!isHomePage()) return;

    if (istV2()) return bootV2();

    loadBaseStyles();
    selbsttestPlatzhalter();

    /* Alles, was gleich gebraucht wird, sofort parallel anfordern. */
    vorladen(KETTE.concat(NEBEN));

    /* Intakte Wissens- und Schutzschichten. Sie sind optional: Ein einzelner
       Fehler darf Eingabe und Fragen-Button nicht blockieren. */
    NEBEN.forEach(function (name) { optionalScript(name); });

    KETTE.reduce(function (kette, name) {
      return kette.then(function () { return optionalScript(name); });
    }, Promise.resolve()).then(function () {
      applyReleaseMarkers();
      window.dispatchEvent(new CustomEvent('sunno:repair-ready', {
        detail: { version: VERSION, corruptEngineDisabled: true }
      }));
      /* Das Ereignis bleibt erhalten, damit vorhandene Zuhoerer nicht warten -
         auch wenn es seit r3k keine nachgeladenen Intent-Schichten mehr gibt. */
      window.dispatchEvent(new CustomEvent('sunno:repair-layers-ready', {
        detail: { version: VERSION, intentSchichten: false }
      }));
    });

    /* Kein Beobachter an der ganzen Seite mehr. Die vier Kennzeichnungen sind
       Diagnose (das Logbuch liest data-sunno-release), keine Funktion - dafuer
       genuegen die Ereignisse, die den Aufbau der Maske melden, und drei
       abgezaehlte Blicke fuer den Fall, dass die Box ohne Ereignis erscheint. */
    window.addEventListener('sunno:home-ready', applyReleaseMarkers);
    window.addEventListener('sunno:rendered', applyReleaseMarkers);
    window.addEventListener('sunno:repair-ready', applyReleaseMarkers);
    /* Am 25.08.2026 gemessen: mit 14 Kettendateien war die Marke nach dem Laden
       NICHT gesetzt. Die drei Blicke liefen alle, bevor sunno-home.js die
       Wurzel gebaut hatte, und der Abschluss der Kette allein hat nicht
       gereicht. Fuenf Blicke statt drei, der letzte nach 12 s. Kosten je Blick:
       zwei getElementById und vier setAttribute - vernachlaessigbar. Die Marke
       ist Diagnose, aber das Logbuch stempelt damit jede Frage. */
    [250, 1000, 2500, 6000, 12000].forEach(function (ms) {
      window.setTimeout(applyReleaseMarkers, ms);
    });
  }

  loadOriginalTheme(0);

  if (isHomePage()) {
    var prehide = document.createElement('style');
    prehide.id = 'sunno-repair-prehide';
    prehide.textContent = '#inutec-tammo-startseite,.section-tammo-solarberater,[data-tammo-legacy="true"]{display:none!important}';
    (document.head || document.documentElement).appendChild(prehide);

    loadBaseStyles();
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bootSunno, { once: true });
    } else {
      bootSunno();
    }
  }
})(document, window);
